export const DrRoundFormInit = {
    temperature: '',
    pulse: '',
    spO2: '',
    respiratoryRate: '',
    BPMorning: '',
    BPEvening: '',
    fastingSugarLevel: '',
    PPSugarLevel: '',
    randomSugarLevel: '',
    sparshaSahatva: [
        { Yakrut: [] },
        { Pleeha: [] },
        { 'Dakshi Vruka': [] },
        { 'Vaam Vruka': [] },
        { 'Apan Kaksha': [] }
    ],
    naad: [],
    yakrutNada: [],
    plihaNada: [],
    Mala: [],
    Mutra: [],
    jivha: [],
    note: '',
    roundType: '',
};

export const medicineInit = {
    medicineName: '',
    days: null,
    whenToTake: [],
    anupan: '',
    course: '',
    howMuch: '',
    date: '',
};
